import NoticeDetail from './NoticeDetail'
export default NoticeDetail;


// WEBPACK FOOTER //
// ./src/components/App/NoticesLoader/NoticeDetail/index.js